import React from "react";
import { Route, Switch, Link, useLocation } from "react-router-dom";
import FourHundFour from "../Components/FourHundFour";
import { Helmet } from 'react-helmet'
import { useState, useEffect } from 'react'
import Prism from "prismjs";
import Myurl from '../Components/Myurl'
import Loader from '../Components/Loader'
import MyUrlmage from "../Components/MyUrlmage";

// Categories Data starts
function Tutorials() {
  let mylocate = useLocation()
  const [name, setName] = useState(<Loader />)
  const [category, setCategory] = useState(<Loader />)
  const [setto, setSetto] = useState()
  const [setminus, setSetminus] = useState()
  const GetCategory = async () => {
    const hello = await fetch(`${Myurl}/videos.json`, {
      method: "GET"
    })
    const TutorialsData = await hello.json()
    function categoriesdata(val) {
      return (
        <>
          <div className="card mx-auto my-2 p-2 align-items-center" style={{ width: '18rem' }}>
            <img src={`${MyUrlmage}/${val.img}`} alt={val.Name} className="rounded-circle img-fluid" />
            <div className="card-body">
              <h5 className="card-title text-center">{val.Name}</h5>
              <p className="card-text text-center">{val.desc}
              </p>
              <Link to={val.To} className="btn btn-primary d-block">Start Learning</Link>
            </div>
          </div>
        </>
      );
    }
    setCategory(<><Helmet><title>Programming Tutorials - Deeptam Research Foundation</title><meta name="description" content="Get Many softwares by its categories - SoftwareMess\" /></Helmet><div className="container"><div className="row mb-4 mt-3">{TutorialsData.map(categoriesdata)}</div></div></>)
  }

  useEffect(() => {
    GetCategory()
  }, [mylocate])

  useEffect(() => {

      const GetProducts = async () => {
    try {
      const res = await fetch(`${Myurl}/courses.json`, {
        method: "GET"
      })
      const datasofvideo = await res.json()
      setTimeout(() => Prism.highlightAll(), 0)
      for (let index = 0; index < datasofvideo.length; index++) {
        const element = datasofvideo[index];
        if (element.To === mylocate.pathname) {
          let prev = Number(element.Sno) - 1
          let cate = element.Categories
          if (element.Categories === cate) {
            for (let indexex = 0; indexex < datasofvideo.length; indexex++) {
              const element = datasofvideo[indexex];
              if (prev === Number(element.Sno) && element.Categories === cate) {
                setSetto(element.To)
              }
            }
          }
        }
      }
      for (let indexexes = 0; indexexes < datasofvideo.length; indexexes++) {
        const element = datasofvideo[indexexes];
        if (element.To === mylocate.pathname) {
          let prev = Number(element.Sno) + 1
          let cate = element.Categories
          if (element.Categories === cate) {
            for (let indexex = 0; indexex < datasofvideo.length; indexex++) {
              const element = datasofvideo[indexex];
              if (prev === Number(element.Sno) && element.Categories === cate) {
                setSetminus(element.To)
              }
            }
          }
        }
      }
      function Disable() {
        if (setminus === undefined || setminus === mylocate.pathname) {
          return "d"
        }
        else {
          return ""
        }
      }
      function DisablePrev() {
        if (setto === undefined || setto === mylocate.pathname) {
          return "d"
        }
        else {
          return ""
        }
      }

      function catedetect() {
        for (let index = 0; index < datasofvideo.length; index++) {
          if (
            datasofvideo[index].To === mylocate.pathname
          ) {
            return (datasofvideo[index].Categories)
          }
        }
      }
      function ncard(val) {
        if (val.Categories === catedetect()) {
          return (
            <>
              <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                <h2><span>{val.Sno + "."} </span>
                  <Link to={val.To} className="text-dark">
                    {val.Name}
                  </Link>
                </h2>
                <p>{val.desc}</p>
                <Link to={val.To} className="btn btn-outline-danger">
                  Start Learning
                </Link>
                <hr />
              </div>
            </>
          )
        }
      }
      function data(val) {
        return (
          <Route exact path={val.To}>
            <Helmet><title>{`${val.Sno}. ${val.Name} - Deeptam Research Foundation`}</title></Helmet>
            <div className="iframe_and_Player">
              <div style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                paddingTop: '56.25%'
              }}>
                <iframe width="100%" title={val.Name} height="1000px" src={val.Iframe} frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    width: '100%',
                    height: '100%'
                  }}></iframe>
              </div>
            </div>
            <ul id="myTab" role="tablist" className="nav nav-tabs">
              <li role="presentation" className="nav-item"><a id="overview-tab" data-toggle="tab" href="#source-code" role="tab"
                aria-controls="overview" aria-selected="true" className="nav-link active text-dark">Description</a></li>
              <li role="presentation" className="nav-item"><a id="announcements-tab" data-toggle="tab" href="#player"
                role="tab" aria-controls="announcements" aria-selected="false" className="nav-link text-dark">Player</a></li>
            </ul>
            <div id="myTabContent" className="tab-content">
              <div id="source-code" role="tabpanel" aria-labelledby="overview-tab" className="tab-pane fade mx-4 mt-3 active show">
                <div className="clearfix py-0 px-0">
                  <h2 className="my-2">{val.Name}</h2>
                  <div className="contentBox">
                    <div dangerouslySetInnerHTML={{ __html: val.content }}>
                    </div>
                  </div>
                </div>
              </div>
              <div id="player" role="tabpanel" aria-labelledby="announcements-tab" className="tab-pane fade mx-4 mt-3">
                <div>
                  {datasofvideo.map(ncard)}
                </div>
              </div>
            </div>
            <div className="container-fluid mb-3 mt-3">
              <div className="row mx-2">
                <div>
                  <Link to={setto}><button id="prev" className="btn btn-danger" disabled={DisablePrev()}>&larr; Previous</button></Link>
                </div>
                <div className="col-md-0 ml-auto">
                  <Link to={setminus}><button id="next" className="btn btn-danger" disabled={Disable()}>Next &rarr;</button></Link>
                </div>
              </div>
            </div>
          </Route>
        )
      }
      setName(
      <Switch>
        {datasofvideo.map(data)}
        <Route>
          <Helmet><title>404 Page Not Found</title>
        </Helmet>
        <FourHundFour />
        </Route>
      </Switch>
    )
    }
    catch {

    }
  }



    GetProducts()
  }, [mylocate, setminus, setto])
  return (
    <>
      <Switch>
        <Route exact path="/videos">{category}</Route>
        {name}
      </Switch>
    </>
  );
}

export default Tutorials;